import React from "react";
import WagerTypes from "../constants/WagerTypes";
import EntriesTable from "./EntriesTable";

const Quinella = ({
  raceInfo,
  entriesInfo,
  idQuinella,
  idBox,
  addToCart,
  disabledAll,
  checkBoxState,
}) => {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="Quinella"
        role="tabpanel"
        aria-labelledby="Quinella"
      >
        <EntriesTable
          raceInfo={raceInfo}
          entriesInfo={entriesInfo}
          wt={WagerTypes.QUINELLA.name}
          idWT={idQuinella}
          idBox={idBox}
          addToCart={addToCart}
          disabledAll={disabledAll}
          checkBoxState={checkBoxState}
        />
      </div>
    </>
  );
};

export default Quinella;
